module.exports = __webpack_public_path__ + "img/call-accept.f3919602.svg";